import { Certificado } from './../models/cetificado.model';
import { Injectable } from '@angular/core';
import { Http, Headers, BaseRequestOptions, RequestOptions, RequestMethod, Jsonp, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'

//Providers
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';

//Models
import { Url } from '../models/url.model';
import { User } from '../models/user.model';
import { ProfileImage } from '../models/profile-image.model';


@Injectable()
export class UserProvider {

    public headers: Headers;
    public options: RequestOptions;
    public urlUser = new Url;
    public params = new URLSearchParams();

    constructor(public http: Http, public configProvider: ConfigProvider, public utilProvider: UtilProvider, private jsonp: Jsonp) {
        this.urlUser = configProvider.url;
        this.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': this.urlUser.SgunAuthorization, 'MobileReferer': this.urlUser.SgunReferer });
        this.options = new RequestOptions({ headers: this.headers });

        this.params.set('format', 'json');
        this.params.set('callback', this.configProvider.CALLBACK);
    }

    getAtividadesInscritasIdsUsuario(guidUsuario: string, congressoAno: number): Promise<any[]> {
        let param = this.params;
        param.set('usuarioGuid', guidUsuario);
        param.set('eventoAno', <any>congressoAno);
        return this.jsonp.get(`${this.urlUser.Cientifico}/shared/apc/getAtividadesInscritasIdsUsuario.ashx`, { search: param })
            .map(res => res.json() as any[]).toPromise()
    }

    getAtividadesAssistidasIdsUsuario(guidUsuario: string, congressoAno: number): Promise<any[]> {
        let param = this.params;
        param.set('usuarioGuid', guidUsuario);
        param.set('eventoAno', <any>congressoAno);
        return this.jsonp.get(`${this.urlUser.Cientifico}/shared/apc/getVisualizacoesUsuario.ashx`, { search: param })
            .map(res => res.json() as any[]).toPromise()
    }

    getProfileImage(image: ProfileImage): Promise<any> {
        return this.http.post(`${this.urlUser.SgunService}/save-image-perfil/json`, JSON.stringify(image), this.options)
            .map((data: any) => data.json())
            .toPromise();
    }

    get(userId: number): Promise<User> {
        return this.http.post(`${this.urlUser.SgunService}/get-usuario-for-apc-by-id/json`, userId, this.options)
            .map((data: any) => data.json() as User).toPromise();
    }

    getPalestrantesFavoritos(usuarioGuid: string, eventoAno: number): Promise<any> {
        let param = this.params;
        param.set('usuarioGuid', <any>usuarioGuid);
        param.set('eventoAno', <any>eventoAno);

        return this.jsonp.get(this.urlUser.Cientifico + '/shared/apc/getPalestrantesFavoritos.ashx', { search: param })
            .map(res => res.json() as any).toPromise();
    }

    updateEmailMarketingPermission(userId: number, permitir: boolean) {

        let user = JSON.parse(localStorage.getItem('user')) as User;
        let model = { UsuarioId: userId, PermiteEmailMarketing: permitir }
        let body = JSON.stringify(model);

        return this.http.post(this.urlUser.SgunService + '/update-permissao-email-marketing/json', body, this.options)
            .map((res: any) => res.json()).toPromise()
            .then(data => {
                if (data) {
                    data = JSON.parse(data).resposta;
                    if (data.codigo == 0) {
                        user.PermiteEmailMarketing = permitir;

                        localStorage.setItem('user', user ? JSON.stringify(user) : "");

                        return data.retorno;
                    }
                    else {
                        return null
                    }
                }
                return null
            });
    }

    getCertificado(model: Certificado): Promise<string> {
        return this.http.post(`${this.urlUser.SgunService}/get-certificado/json`, model, this.options)
            .map((data: any) => data.json()).toPromise();
    }
}




// WEBPACK FOOTER //
// ./src/providers/user-provider.ts